import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { VideoSection } from "../components/site/VideoSection";
import { StrategicResource } from "../components/site/StrategicResource";
import { Production } from "../components/site/Production";
import { Advantages } from "../components/site/Advantages";
import { Applications } from "../components/site/Applications";
import { Certification } from "../components/site/Certification";
import { Market } from "../components/site/Market";
import { WhyNeroChar } from "../components/site/WhyNeroChar";
import { ComingSoon } from "../components/site/ComingSoon";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { Toaster } from "../components/ui/sonner";
import { smoothScrollTo } from "../lib/scroll";

export default function NeroChar() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => smoothScrollTo(id), 350);
    }
  }, [location]);

  return (
    <div className="font-body bg-background text-nero-ink antialiased">
      <Navbar />
      <main>
        <Hero />
        <VideoSection />
        <StrategicResource />
        <Production />
        <Advantages />
        <Applications />
        <Certification />
        <Market />
        <WhyNeroChar />
        <ComingSoon />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}
